export default {
  'meeting.stand': 'Booth {{ stand_number }}',
  'meeting_scheduler.standLocation': '{{ companyName }} booth {{ standNumberFull }}',
  'crm.phone.types.mobile': 'Cell phone',
  'expanded_contact.meeting.contactNumber': 'Cell number: ',
  'meeting.mobileNumberLabel': 'Cell Number:',
  'meeting.phoneNumberMissing': '<a href="{{ updatePhoneUrl }}">Please add a cell number</a>',
};
